import { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { toast } from 'react-toastify'
import PageContainer from '../components/layout/PageContainer'
import Button from '../components/common/Button'
import Dialog from '../components/common/Dialog'
import ConfirmDialog from '../components/common/ConfirmDialog'
import Searchbox from '../components/common/Searchbox'
import Pagination from '../components/common/Pagination'
import Select from '../components/common/Select'
import { scanSessionsService } from '../services/api/scanSessionsService'

const initialScanSessions = [
  {
    id: 'session-001',
    name: 'Weekly WordPress accessibility sweep',
    createdAt: 'June 20, 2026',
    scanMode: 'Scheduled',
    frequency: 'Weekly',
    initialRun: 'June 12, 2026, 09:00 AM',
    previousRun: 'June 18, 2026, 09:00 AM',
    nextRun: 'Monday, 09:00 AM',
    lastRun: 'June 18, 2026',
    status: 'active',
    result: '19 violations',
    stages: [
      { label: 'Created', value: 'June 12, 2026', status: 'completed' },
      { label: 'Initial scan', value: 'June 12, 2026, 09:00 AM', status: 'completed' },
      { label: 'Previous scan', value: 'June 18, 2026, 09:00 AM', status: 'completed' },
      { label: 'Next scan', value: 'Monday, 09:00 AM', status: 'pending' },
    ],
    sites: [
      {
        id: '6996c09a0dba6f40e608ae6a',
        name: 'Violet Dinosaur',
        url: 'https://violet-dinosaur-778127.hostingersite.com',
        status: 'completed',
        score: 86,
        pages: [
          { name: 'Home', url: '/', violations: 3, status: 'completed' },
          { name: '27-march-test', url: '/27-march-test/', violations: 5, status: 'completed' },
          { name: 'Custom ADA Fixed', url: '/custom-ada-fixed/', violations: 1, status: 'completed' },
        ],
      },
      {
        id: '6996c09a0dba6f40e608ae6a',
        name: 'Shop Demo',
        url: 'https://shop.example.com',
        status: 'running',
        score: 72,
        pages: [
          { name: 'Product Listing', url: '/collections/all', violations: 8, status: 'running' },
          { name: 'Product Detail', url: '/products/sample', violations: 4, status: 'pending' },
          { name: 'Cart', url: '/cart', violations: 2, status: 'pending' },
        ],
      },
      {
        id: '6996c09a0dba6f40e608ae6a',
        name: 'Marketing Site',
        url: 'https://marketing.example.com',
        status: 'completed',
        score: 91,
        pages: [
          { name: 'Landing Page', url: '/', violations: 2, status: 'completed' },
          { name: 'Pricing', url: '/pricing', violations: 1, status: 'completed' },
          { name: 'Contact', url: '/contact', violations: 0, status: 'completed' },
        ],
      },
    ],
  },
  {
    id: 'session-002',
    name: 'Manual client review batch',
    createdAt: 'June 19, 2026',
    scanMode: 'Manual',
    frequency: 'Run once',
    initialRun: 'June 19, 2026, 02:15 PM',
    previousRun: 'June 19, 2026, 02:15 PM',
    nextRun: 'Not scheduled',
    lastRun: 'June 19, 2026',
    status: 'completed',
    result: '8 violations',
    stages: [
      { label: 'Created', value: 'June 19, 2026', status: 'completed' },
      { label: 'Initial scan', value: 'June 19, 2026, 02:15 PM', status: 'completed' },
      { label: 'Previous scan', value: 'June 19, 2026, 02:15 PM', status: 'completed' },
      { label: 'Next scan', value: 'Not scheduled', status: 'paused' },
    ],
    sites: [
      {
        id: '6996c09a0dba6f40e608ae6a',
        name: 'Violet Dinosaur',
        url: 'https://violet-dinosaur-778127.hostingersite.com',
        status: 'completed',
        score: 88,
        pages: [
          { name: 'Home', url: '/', violations: 2, status: 'completed' },
          { name: 'asad-test', url: '/asad-test/', violations: 6, status: 'completed' },
        ],
      },
    ],
  },
  {
    id: 'session-003',
    name: 'Monthly full-site compliance pack',
    createdAt: 'June 1, 2026',
    scanMode: 'Scheduled',
    frequency: 'Monthly',
    initialRun: 'June 1, 2026, 10:00 AM',
    previousRun: 'June 1, 2026, 10:00 AM',
    nextRun: 'July 1, 10:00 AM',
    lastRun: 'June 1, 2026',
    status: 'paused',
    result: '24 violations',
    stages: [
      { label: 'Created', value: 'June 1, 2026', status: 'completed' },
      { label: 'Initial scan', value: 'June 1, 2026, 10:00 AM', status: 'completed' },
      { label: 'Previous scan', value: 'June 1, 2026, 10:00 AM', status: 'completed' },
      { label: 'Next scan', value: 'July 1, 10:00 AM', status: 'paused' },
    ],
    sites: [
      {
        id: '6996c09a0dba6f40e608ae6a',
        name: 'Violet Dinosaur',
        url: 'https://violet-dinosaur-778127.hostingersite.com',
        status: 'paused',
        score: 80,
        pages: [
          { name: 'All Pages', url: '54 selected pages', violations: 24, status: 'paused' },
        ],
      },
    ],
  },
]

const statusStyles = {
  active: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  running: 'bg-sky-50 text-sky-700 border-sky-200',
  pending: 'bg-amber-50 text-amber-700 border-amber-200',
  paused: 'bg-gray-100 text-gray-600 border-gray-200',
  failed: 'bg-red-50 text-red-700 border-red-200',
}

const statusIcons = {
  active: 'mdi:check-circle',
  completed: 'mdi:check-circle',
  running: 'mdi:loading',
  pending: 'mdi:clock-outline',
  paused: 'mdi:pause-circle',
  failed: 'mdi:alert-circle',
}

const getSessionPageCount = (session) => session.pageCount || session.sites?.reduce((total, site) => total + site.pages.length, 0) || 0

const getSessionViolationCount = (session) => session.totalViolations || session.sites?.reduce(
    (total, site) => total + site.pages.reduce((pageTotal, page) => pageTotal + page.violations, 0),
    0,
  ) || 0

const getSessionSiteCount = (session) => session.siteCount || session.sites?.length || 0

const StatTile = ({ icon, label, value, tone = 'blue' }) => {
  const tones = {
    blue: 'bg-sky-50 text-primary',
    green: 'bg-emerald-50 text-emerald-600',
    amber: 'bg-amber-50 text-amber-600',
  }

  return (
    <div className="rounded-lg border border-border-light bg-white p-4">
      <div className="flex items-center gap-3">
        <span className={`flex h-10 w-10 items-center justify-center rounded-lg ${tones[tone]}`}>
          <Icon icon={icon} className="text-xl" />
        </span>
        <div>
          <p className="text-xs font-medium text-text-secondary">{label}</p>
          <p className="text-xl font-bold text-text-dark">{value}</p>
        </div>
      </div>
    </div>
  )
}

const StatusBadge = ({ status }) => (
  <span className={`w-[100px] inline-flex items-center gap-1 rounded-full border px-2 py-1 text-xs font-semibold capitalize ${statusStyles[status] || statusStyles.paused}`}>
    <Icon
      icon={statusIcons[status] || statusIcons.paused}
      className={status === 'running' ? 'animate-spin' : ''}
    />
    {status}
  </span>
)

const SiteAccordion = ({ sessionId, site, isOpen, onToggle, onOpenHistory }) => (
  <div className="overflow-hidden rounded-xl border border-border-light bg-white shadow-sm">
    <button
      type="button"
      onClick={onToggle}
      className="flex w-full flex-col gap-3 px-5 py-4 text-left transition-colors hover:bg-gray-50 md:flex-row md:items-center md:justify-between"
    >
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <h3 className="text-sm font-bold text-text-dark">{site.name}</h3>
          <StatusBadge status={site.status} />
        </div>
        <p className="mt-1 truncate text-xs text-text-secondary">{site.url}</p>
        <p className="mt-0.5 text-xs font-mono text-gray-400">ID: {site.id}</p>
      </div>
      <div className="flex flex-wrap items-center gap-3 text-sm">
        <span className="font-semibold text-text-dark">{site.pages.length} pages</span>
        <span className="font-semibold text-primary">{site.score}% score</span>
        <Icon
          icon={isOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'}
          className="text-xl text-gray-400"
        />
      </div>
    </button>

    {isOpen && (
      <div className="border-t border-gray-100">
        <div className="grid gap-3 bg-gray-50 px-5 py-4 md:grid-cols-4">
          <div className="rounded-lg bg-white p-3">
            <p className="text-xs text-text-secondary">Site Name</p>
            <p className="text-sm font-semibold text-text-dark">{site.name}</p>
          </div>
          <div className="rounded-lg bg-white p-3">
            <p className="text-xs text-text-secondary">Website ID</p>
            <p className="truncate text-sm font-mono text-text-dark">{site.id}</p>
          </div>
          <div className="rounded-lg bg-white p-3">
            <p className="text-xs text-text-secondary">Score</p>
            <p className="text-sm font-semibold text-primary">{site.score}%</p>
          </div>
          <div className="flex items-end rounded-lg bg-white p-3">
            <Button
              variant="secondary"
              size="sm"
              icon="mdi:eye-outline"
              onClick={() => onOpenHistory(site.id)}
              className="h-9 whitespace-nowrap"
            >
              View
            </Button>
          </div>
        </div>

        <div className="divide-y divide-gray-100">
          {site.pages.map((page) => (
            <div key={`${sessionId}-${site.name}-${page.name}`} className="grid gap-3 px-5 py-4 md:grid-cols-[minmax(0,1fr)_110px_120px] md:items-center">
              <div className="min-w-0">
                <p className="text-sm font-semibold text-text-dark">{page.name}</p>
                <p className="truncate text-xs text-text-secondary">{page.url}</p>
              </div>
              <p className="text-sm font-semibold text-text-dark">{page.violations} violations</p>
              <StatusBadge status={page.status} />
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
)

const SessionDetailsDialog = ({ session, onClose, onOpenHistory }) => {
  const [openSiteIds, setOpenSiteIds] = useState([])

  useEffect(() => {
    setOpenSiteIds(session?.sites?.[0] ? [session.sites[0].name] : [])
  }, [session])

  if (!session) return null

  const toggleSite = (siteName) => {
    setOpenSiteIds((prev) =>
      prev.includes(siteName)
        ? prev.filter((name) => name !== siteName)
        : [...prev, siteName],
    )
  }

  return (
    <Dialog
      isOpen={!!session}
      onClose={onClose}
      title={session.name}
      size="xl"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </>
      }
    >
      <div className="space-y-5 pb-3">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
        <div className="rounded-xl border border-gray-100 bg-gray-50 p-4">
          <p className="text-xs font-medium text-text-secondary">Sites</p>
          <p className="mt-1 text-xl font-bold text-text-dark">{getSessionSiteCount(session)}</p>
        </div>
        <div className="rounded-xl border border-gray-100 bg-gray-50 p-4">
          <p className="text-xs font-medium text-text-secondary">Pages</p>
          <p className="mt-1 text-xl font-bold text-text-dark">{getSessionPageCount(session)}</p>
        </div>
        <div className="rounded-xl border border-gray-100 bg-gray-50 p-4">
          <p className="text-xs font-medium text-text-secondary">Violations</p>
          <p className="mt-1 text-xl font-bold text-text-dark">{getSessionViolationCount(session)}</p>
        </div>
        <div className="rounded-xl border border-gray-100 bg-gray-50 p-4">
          <p className="text-xs font-medium text-text-secondary">Next Run</p>
          <p className="mt-1 text-sm font-bold text-text-dark">{session.nextRun || 'Not scheduled'}</p>
        </div>
        <div className="rounded-xl border border-gray-100 bg-gray-50 p-4">
          <p className="text-xs font-medium text-text-secondary">Status</p>
          <p className="mt-1 text-sm font-bold capitalize text-text-dark">{session.status}</p>
        </div>
      </div>

      <div className="rounded-xl border border-border-light bg-white shadow-sm">
        <div className="border-b border-gray-100 px-5 py-4">
          <h3 className="text-sm font-bold text-text-dark">Schedule Details</h3>
          <p className="text-xs text-text-secondary">
            Initial, previous, and upcoming schedule stages for this session.
          </p>
        </div>

        <div className="grid gap-4 p-5 md:grid-cols-3">
          <div className="rounded-xl bg-sky-50 p-4">
            <p className="text-xs font-semibold text-sky-700">Initial Run</p>
            <p className="mt-1 text-sm font-bold text-text-dark">{session.initialRun || 'Not run yet'}</p>
          </div>
          <div className="rounded-xl bg-emerald-50 p-4">
            <p className="text-xs font-semibold text-emerald-700">Previous Run</p>
            <p className="mt-1 text-sm font-bold text-text-dark">{session.previousRun || 'Not run yet'}</p>
          </div>
          <div className="rounded-xl bg-amber-50 p-4">
            <p className="text-xs font-semibold text-amber-700">Next Run</p>
            <p className="mt-1 text-sm font-bold text-text-dark">{session.nextRun || 'Not scheduled'}</p>
          </div>
        </div>

        <div className="grid gap-4 border-t border-gray-100 p-5 md:grid-cols-2 2xl:grid-cols-4">
          {session.stages.map((stage, index) => (
            <div key={stage.label} className="relative rounded-xl border border-gray-200 bg-white p-4">
              <div className="mb-2 flex items-center justify-between gap-2">
                <span className="flex p-2 items-center justify-center rounded-full bg-primary/10 text-xs font-bold text-primary">
                  {index + 1}
                </span>
                <StatusBadge status={stage.status} />
              </div>
              <p className="text-xs font-semibold uppercase text-gray-500">{stage.label}</p>
              <p className="mt-1 text-sm font-bold text-text-dark">{stage.value}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        {session.sites.map((site) => (
          <SiteAccordion
            key={`${session.id}-${site.name}`}
            sessionId={session.id}
            site={site}
            isOpen={openSiteIds.includes(site.name)}
            onToggle={() => toggleSite(site.name)}
            onOpenHistory={onOpenHistory}
          />
        ))}
      </div>
      </div>
    </Dialog>
  )
}

const ScanPlannerPage = () => {
  const navigate = useNavigate()
  const [sessions, setSessions] = useState([])
  const [selectedSession, setSelectedSession] = useState(null)
  const [deleteTarget, setDeleteTarget] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isDeleting, setIsDeleting] = useState(false)
  const [isTriggeringRun, setIsTriggeringRun] = useState(null)
  const [isLoadingDetails, setIsLoadingDetails] = useState(false)
  const [page, setPage] = useState(1)
  const [limit] = useState(10)
  const [totalResults, setTotalResults] = useState(0)
  const [totalPages, setTotalPages] = useState(1)
  const [search, setSearch] = useState('')
  const [statusFilter, setStatusFilter] = useState('')

  const fetchSessions = useCallback(async (p = 1, s = '', status = '') => {
    setIsLoading(true)
    try {
      const params = { page: p, limit }
      if (s) params.search = s
      if (status) params.status = status

      const response = await scanSessionsService.getSessions(params)
      if (response.success && response.data) {
        const data = response.data
        setSessions(data.results || [])
        setTotalResults(data.totalResults || 0)
        setTotalPages(data.totalPages || 1)
        setPage(data.page || p)
      }
    } catch (error) {
      toast.error('Failed to load scan sessions')
      console.error('Error fetching scan sessions:', error)
    } finally {
      setIsLoading(false)
    }
  }, [limit])

  useEffect(() => {
    fetchSessions(page, search, statusFilter)
  }, [fetchSessions, page, search, statusFilter])

  const handleSearch = useCallback((value) => {
    setPage(1)
    setSearch(value)
  }, [])

  const handleStatusChange = (e) => {
    setPage(1)
    setStatusFilter(e.target.value)
  }

  const handlePageChange = (newPage) => {
    if (typeof newPage === 'number' && Number.isFinite(newPage) && newPage > 0) {
      setPage(newPage)
    }
  }

  const handleViewSession = async (session) => {
    setIsLoadingDetails(true)
    setSelectedSession(session)
    try {
      const response = await scanSessionsService.getSessionById(session.id)
      if (response.success && response.data) {
        setSelectedSession(response.data)
      }
    } catch (error) {
      toast.error('Failed to load session details')
      console.error('Error fetching session details:', error)
    } finally {
      setIsLoadingDetails(false)
    }
  }

  const handleOpenHistory = (websiteId) => {
    if (!websiteId) return
    navigate(`/website-scans/${websiteId}`)
  }

  const handleDeleteSession = async () => {
    if (!deleteTarget) return
    setIsDeleting(true)
    try {
      await scanSessionsService.deleteSession(deleteTarget.id)
      setSessions((prev) => prev.filter((session) => session.id !== deleteTarget.id))
      if (selectedSession?.id === deleteTarget.id) {
        setSelectedSession(null)
      }
      toast.success('Scan session deleted successfully')
    } catch (error) {
      toast.error('Failed to delete scan session')
      console.error('Error deleting scan session:', error)
    } finally {
      setIsDeleting(false)
      setDeleteTarget(null)
    }
  }

  const handleTriggerRun = async (sessionId) => {
    setIsTriggeringRun(sessionId)
    try {
      const response = await scanSessionsService.triggerRun(sessionId)
      if (response.success) {
        toast.success('Scan started successfully')
        // Refresh the session list to show updated status
        await fetchSessions()
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to start scan'
      toast.error(errorMessage)
      console.error('Error triggering scan:', error)
    } finally {
      setIsTriggeringRun(null)
    }
  }

  const totalSites = sessions.reduce((total, session) => total + getSessionSiteCount(session), 0)
  const totalPageCount = sessions.reduce((total, session) => total + getSessionPageCount(session), 0)
  const totalViolations = sessions.reduce((total, session) => total + getSessionViolationCount(session), 0)

  return (
    <PageContainer
      title="Scan Planner"
      subtitle="View scan sessions created from Integrations, including selected sites, pages, results, and status."
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <StatTile icon="mdi:calendar-check" label="Scan Sessions" value={isLoading ? '...' : sessions.length} />
        <StatTile icon="mdi:web" label="Sites Covered" value={isLoading ? '...' : totalSites} tone="green" />
        <StatTile icon="mdi:file-document-multiple-outline" label="Pages Covered" value={isLoading ? '...' : totalPageCount} tone="amber" />
      </div>

      <div className="mt-6 rounded-xl border border-border-light bg-white">
        <div className="flex flex-col gap-3 border-b border-gray-100 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="text-sm font-bold text-text-dark">Scan Sessions</h2>
            <p className="text-xs text-text-secondary">
              One row can include multiple sites and multiple selected pages.
            </p>
          </div>
          <span className="inline-flex w-fit items-center gap-1 rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold text-primary">
            <Icon icon="mdi:database-eye-outline" />
            {sessions.length} sessions
          </span>
        </div>

        <div className="flex flex-col md:flex-row items-center py-4 justify-between gap-2">
          <p className="text-sm font-semibold text-text-dark">Scan Sessions</p>
          <div className="flex items-center gap-2 flex-col md:flex-row md:w-[700px]">
            <Searchbox
              placeholder="Search sessions by name"
              onSearch={handleSearch}
              delay={600}
            />
            <Select
              value={statusFilter}
              onChange={handleStatusChange}
              wrapperClassName=""
            >
              <option value="">All Statuses</option>
              <option value="pending">Pending</option>
              <option value="running">Running</option>
              <option value="completed">Completed</option>
              <option value="failed">Failed</option>
            </Select>
          </div>
        </div>

        <div className="grid overflow-x-auto">
          <table className="w-full  divide-y divide-gray-100">
            <thead className="bg-gray-50">
              <tr>
                <th className="w-[22%] px-4 py-3 text-left text-xs font-bold uppercase text-gray-500">Session Name</th>
                <th className="w-[11%] px-4 py-3 text-left text-xs font-bold uppercase text-gray-500">Coverage</th>
                <th className="w-[10%] px-4 py-3 text-left text-xs font-bold uppercase text-gray-500">Mode</th>
                <th className="w-[16%] px-4 py-3 text-left text-xs font-bold uppercase text-gray-500">Schedule</th>
                <th className="w-[13%] px-4 py-3 text-left text-xs font-bold uppercase text-gray-500">Result</th>
                <th className="w-[10%] px-4 py-3 text-left text-xs font-bold uppercase text-gray-500">Status</th>
                <th className="w-[18%] px-4 py-3 text-right text-xs font-bold uppercase text-gray-500">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 bg-white">
              {isLoading ? (
                <tr>
                  <td colSpan={7} className="px-4 py-12 text-center">
                    <Icon icon="mdi:loading" className="mx-auto mb-2 animate-spin text-4xl text-primary" />
                    <p className="text-sm font-semibold text-text-dark">Loading scan sessions...</p>
                  </td>
                </tr>
              ) : sessions.length === 0 ? (
                <tr>
                  <td colSpan={7} className="px-4 py-12 text-center">
                    <Icon icon="mdi:calendar-remove-outline" className="mx-auto mb-2 text-4xl text-gray-300" />
                    <p className="text-sm font-semibold text-text-dark">No scan sessions found</p>
                    <p className="text-xs text-text-secondary">Sessions created from Integrations will appear here.</p>
                  </td>
                </tr>
              ) : (
                sessions.map((session) => (
                <tr key={session.id} className="hover:bg-gray-50/70">
                  <td className="px-4 py-4">
                    <div className="min-w-0">
                      <p className="truncate text-sm font-semibold text-text-dark">{session.name}</p>
                      <p className="mt-0.5 text-xs text-text-secondary">Created {session.createdAt}</p>
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <p className="text-sm font-semibold text-text-dark">{getSessionSiteCount(session)} {getSessionSiteCount(session) === 1 ? 'site' : 'sites'}</p>
                    <p className="text-xs text-text-secondary">{getSessionPageCount(session)} {getSessionPageCount(session) === 1 ? 'page' : 'pages'}</p>
                  </td>
                  <td className="px-4 py-4">
                    <p className="text-sm font-semibold text-text-dark">{session.scanMode}</p>
                  </td>
                  <td className="px-4 py-4">
                    <p className="text-sm font-semibold text-text-dark">{session.frequency}</p>
                    <p className="text-xs text-text-secondary">{session.nextRun || 'Not scheduled'}</p>
                  </td>
                  <td className="px-4 py-4">
                    <p className="text-sm font-semibold text-text-dark">
                      {getSessionViolationCount(session) === 0 ? 'No violations' : `${getSessionViolationCount(session)} ${getSessionViolationCount(session) === 1 ? 'violation' : 'violations'}`}
                    </p>
                    {session.lastRun && <p className="text-xs text-text-secondary">Last: {session.lastRun}</p>}
                  </td>
                  <td className="px-4 py-4">
                    <StatusBadge status={session.status} />
                  </td>
                  <td className="px-4 py-4 text-right">
                    <div className="flex items-center justify-end gap-1.5">
                      {session.scanMode === 'Scheduled' && (
                        <Button
                          variant="secondary"
                          size="sm"
                          icon={isTriggeringRun === session.id ? 'mdi:loading' : 'mdi:play-circle-outline'}
                          onClick={() => handleTriggerRun(session.id)}
                          disabled={isTriggeringRun === session.id || session.status === 'running'}
                          className="h-8 px-2 text-xs whitespace-nowrap"
                          title="Trigger immediate run"
                        >
                          {isTriggeringRun === session.id ? '' : 'Run'}
                        </Button>
                      )}
                      <Button
                        variant="secondary"
                        size="sm"
                        icon="mdi:eye-outline"
                        onClick={() => handleViewSession(session)}
                        className="h-8 px-2 text-xs whitespace-nowrap"
                        title="View details"
                      >
                        View
                      </Button>
                      <button
                        type="button"
                        onClick={() => setDeleteTarget(session)}
                        disabled={isDeleting}
                        title="Delete session"
                        className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-red-100 bg-red-50 text-red-600 transition-colors hover:bg-red-100 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <Icon icon="mdi:delete-outline" className="text-base" />
                      </button>
                    </div>
                  </td>
                </tr>
              )))
              }
            </tbody>
          </table>
        </div>

        {!isLoading && totalResults > 0 && (
          <div className="flex items-center justify-between mt-4 pt-4 border-t border-border-light px-4 pb-4">
            <p className="text-sm text-text-secondary">
              Showing {(page - 1) * limit + 1} to {Math.min(page * limit, totalResults)} of{' '}
              {totalResults} results
            </p>
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              totalDocs={totalResults}
              limit={limit}
              onPageChange={handlePageChange}
              hasPrevPage={page > 1}
              hasNextPage={page < totalPages}
            />
          </div>
        )}
      </div>

      <SessionDetailsDialog
        session={selectedSession}
        onClose={() => {
          setSelectedSession(null)
          setIsLoadingDetails(false)
        }}
        onOpenHistory={handleOpenHistory}
      />

      <ConfirmDialog
        isOpen={!!deleteTarget}
        onClose={() => setDeleteTarget(null)}
        onConfirm={handleDeleteSession}
        title="Delete Scan Session"
        message={
          deleteTarget
            ? `Are you sure you want to delete "${deleteTarget.name}"? This removes the session from this list.`
            : ''
        }
        confirmText={isDeleting ? 'Deleting...' : 'Delete'}
        cancelText="Cancel"
        variant="danger"
        icon="mdi:delete-alert"
      />
    </PageContainer>
  )
}

export default ScanPlannerPage
